<div mat-dialog-title class="app-dialog-header">
  <mat-icon class="app-dialog-header__icon" aria-hidden="true">workspaces</mat-icon>
  <div class="app-dialog-header__heading">
    <h2>Opening workspace</h2>
    <p>Loading your workspace and settings.</p>
  </div>
</div>
<section class="load-workspace gap-3 p-4" aria-label="Loading workspace">
  <div class="load-workspace__image">
    <img [src]="loadingImageUrl || '../../../assets/placeholder.svg'"
      [alt]="loadingSchemeName || 'Workspace'">
  </div>
  <div class="load-workspace__copy gap-1">
    <strong>{{loadingSchemeName || 'Loading workspace'}}</strong>
    <span>Loading workspace...</span>
  </div>
  <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="40"></mat-progress-spinner>
</section>
